import { Strings } from "src/constants";
import { AnalyticBody } from "./analyticBody";

export class BOPAnalyticBody extends AnalyticBody {
    title: string = Strings.ANALYSIS_BOP_COMPE
}